import { NgModule } from '@angular/core'
import {
  LucideAppWindow,
  LucideArrowLeft,
  LucideArrowRight,
  LucideArrowRightLeft,
  LucideBox,
  LucideBan,
  LucideBuilding2,
  LucideChartLine,
  LucideChartNoAxesGantt,
  LucideCheck,
  LucideChevronDown,
  LucideChevronRight,
  LucideChevronUp,
  LucideChevronsDown,
  LucideChevronsUp,
  LucideCircleAlert,
  LucideCircleCheck,
  LucideCircleQuestionMark,
  LucideCircleX,
  LucideClock,
  LucideCloudAlert,
  LucideCloudDownload,
  LucideCloudUpload,
  LucideCopy,
  LucideDownload,
  LucideDynamicIcon,
  LucideEllipsisVertical,
  LucideExpand,
  LucideExternalLink,
  LucideEye,
  LucideFileText,
  LucideFlaskConical,
  LucideFunnel,
  LucideGripVertical,
  LucideHistory,
  LucideHouse,
  LucideIdCard,
  LucideInfo,
  LucideKeyRound,
  LucideLayers,
  LucideLoaderCircle,
  LucideLocateFixed,
  LucideLock,
  LucideLockOpen,
  LucideLogOut,
  LucideLogIn,
  LucideMail,
  LucideMapPin,
  LucideMegaphone,
  LucideMenu,
  LucideMessageSquare,
  LucideMessageSquareOff,
  LucideMonitor,
  LucidePen,
  LucidePlus,
  LucideReceipt,
  LucideRefreshCw,
  LucideRocket,
  LucideRotateCcw,
  LucideRotateCw,
  LucideSave,
  LucideSearch,
  LucideSettings,
  LucideShare2,
  LucideShield,
  LucideShieldCheck,
  LucideShieldHalf,
  LucideSquarePen,
  LucideTerminal,
  LucideTrash2,
  LucideUpload,
  LucideUser,
  LucideUsers,
  LucideWrench,
  LucideX,
} from '@lucide/angular'

// Lucide ships one standalone component per glyph, so every icon a template uses has to be
// imported somewhere. Collecting them here keeps the consuming NgModules' import arrays from
// growing an entry per glyph — add to this list whenever a template reaches for a new glyph.
// LucideDynamicIcon is the one exception: it takes the glyph as a `[lucideIcon]` binding, for
// the handful of places where the icon comes from data rather than the template.
const LUCIDE_ICONS = [
  LucideAppWindow,
  LucideArrowLeft,
  LucideArrowRight,
  LucideArrowRightLeft,
  LucideBox,
  LucideBan,
  LucideBuilding2,
  LucideChartLine,
  LucideChartNoAxesGantt,
  LucideCheck,
  LucideChevronDown,
  LucideChevronRight,
  LucideChevronUp,
  LucideChevronsDown,
  LucideChevronsUp,
  LucideCircleAlert,
  LucideCircleCheck,
  LucideCircleQuestionMark,
  LucideCircleX,
  LucideClock,
  LucideCloudAlert,
  LucideCloudDownload,
  LucideCloudUpload,
  LucideCopy,
  LucideDownload,
  LucideDynamicIcon,
  LucideEllipsisVertical,
  LucideExpand,
  LucideExternalLink,
  LucideEye,
  LucideFileText,
  LucideFlaskConical,
  LucideFunnel,
  LucideGripVertical,
  LucideHistory,
  LucideHouse,
  LucideIdCard,
  LucideInfo,
  LucideKeyRound,
  LucideLayers,
  LucideLoaderCircle,
  LucideLocateFixed,
  LucideLock,
  LucideLockOpen,
  LucideLogOut,
  LucideLogIn,
  LucideMail,
  LucideMapPin,
  LucideMegaphone,
  LucideMenu,
  LucideMessageSquare,
  LucideMessageSquareOff,
  LucideMonitor,
  LucidePen,
  LucidePlus,
  LucideReceipt,
  LucideRefreshCw,
  LucideRocket,
  LucideRotateCcw,
  LucideRotateCw,
  LucideSave,
  LucideSearch,
  LucideSettings,
  LucideShare2,
  LucideShield,
  LucideShieldCheck,
  LucideShieldHalf,
  LucideSquarePen,
  LucideTerminal,
  LucideTrash2,
  LucideUpload,
  LucideUser,
  LucideUsers,
  LucideWrench,
  LucideX,
]

@NgModule({
  imports: LUCIDE_ICONS,
  exports: LUCIDE_ICONS,
})
export class LucideIconsModule {}
